<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{form.modal.title}}</h4>
        </div>
        <div class="modal-body">

          <div class="panel-body">
            <div class="row panel-heading">
              <div class="col-sm-12 text-center">
                <form class="form-inline search-fields" @submit.prevent="form.onSiteSearch('siteId')">
                  <div class="form-group">
                    <select class="form-control" id="searchField" name="searchField" v-model="form.siteSearch.field">
                      <option value="site">Site</option>
                      <option value="zone">Zone</option>
                      <option value="location">Location</option>
                      <option value="route">Route</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <input type="search" placeholder="search sites" class="form-control" v-model="form.siteSearch.term">
                    <span class="input-group-addon pointer" v-on:click="form.onSiteSearch('siteId')" title="search"><i class="fa fa-search"></i></span>
                  </div>
                  <i class="fa fa-spinner fa-spin" v-if="siteSearch.loading"></i>
                  <button type="button" class="btn btn-default ml-20" v-if="!siteSearch.loading" v-on:click="newSite">Create new site</button>
                </form>
              </div>
            </div>
          </div>

          <form @submit.prevent="form.onSubmit" @keydown="form.errors.clear($event.target.id)">
            <input type="hidden" name="id" v-model="form.data.id">

            <div class="form-group" :class="{'has-error': form.errors.has('siteId') }">
              <label class="control-label">Site</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.siteId" v-on:change="setSelected">
                  <option v-for="item in siteSearch.sites" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('siteId')" v-text="form.errors.get('siteId')"></span>
            </div>

            <div class="site-details">
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-sm-offset-2"><strong>Name:</strong> {{ siteSearch.selected.name }}</div>
                <div class="col-xs-12 col-sm-4"><strong>Address:</strong> {{ siteSearch.selected.address }}, {{ siteSearch.selected.city }}, {{ stateName(siteSearch.selected.stateId) }} {{ siteSearch.selected.zip }}</div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-sm-offset-2"><strong>Zone:</strong> {{ zoneName(siteSearch.selected.zoneId) }}</div>
                <div class="col-xs-12 col-sm-4"><strong>Route:</strong> {{ routeName(siteSearch.selected.routeId) }}</div>
              </div>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('observedDate') }">
              <label class="control-label">Date</label>
              <date-picker v-model="form.data.observedDate"></date-picker>
              <span class="help-block" v-if="form.errors.has('observedDate')" v-text="form.errors.get('observedDate')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('observedTime') }">
              <label class="control-label">Time <span class="optional">(optional)</span></label>
              <masked-input id="observedTime" v-model="form.data.observedTime" mask="11:11" placeholder="HH:MM" class="form-control" />
              <span class="help-block" v-if="form.errors.has('observedTime')" v-text="form.errors.get('observedTime')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('inspectorId') }">
              <label class="control-label">Inspector</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.inspectorId">
                  <option></option>
                  <option v-for="item in applicators" v-bind:value="item.id">{{item.attributes.inspector}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('inspectorId')" v-text="form.errors.get('inspectorId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('duration') }">
              <label class="control-label">Duration (in minutes) <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="duration" v-model="form.data.duration">
              <span class="help-block" v-if="form.errors.has('duration')" v-text="form.errors.get('duration')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('mosquitoCount') }">
              <label class="control-label">Mosquito Species <span class="optional">(optional)</span></label>
              <div v-for="(species, index) in form.data.landingRateMosquitoes">
                <div class="input-group">
                  <span class="input-group-addon">{{index + 1}}</span>
                  <select class="form-control" v-model="form.data.landingRateMosquitoes[index]['mosquitoSpecyId']" placeholder="Mosquito Species">
                    <option></option>
                    <option v-for="m in mosquitoes" v-bind:value="m.id">{{m.attributes.name}}</option>
                  </select>
                  <input type="text" v-model="form.data.landingRateMosquitoes[index]['mosquitoCount']" class="form-control" placeholder="(Mosquito Count)">
                  <span class="input-group-addon"><i class="fa fa-trash pointer" v-on:click="removeMosquito(index)" title="Remove mosquito"></i></span>
                </div>
              </div>
              <button type="button" class="btn btn-small" v-on:click="addMosquito()" title="Add contract"><i class="fa fa-plus"></i></button>
              <span class="help-block" v-if="form.errors.has('contracts')" v-text="form.errors.get('contracts')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('weather') }">
              <label class="control-label">Weather <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="weather" v-model="form.data.weather">
              <span class="help-block" v-if="form.errors.has('weather')" v-text="form.errors.get('weather')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('workStatus') }">
              <label class="control-label">Work Status</label>
              <select class="form-control" v-model="form.data.workStatus">
                <option v-for="item in workStatus">{{item}}</option>
              </select>
              <span class="help-block" v-if="form.errors.has('workStatus')" v-text="form.errors.get('workStatus')"></span>
            </div>

            <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
            <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
          </form>
        </div>
        <div class="modal-footer">
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>

<script>
  import LoadingButton from '@/components/loading-button';
  import DatePicker from '@/components/date-picker';
  import MaskedInput from 'vue-masked-input';

  export default {
    name: 'landing-rate-form',

    props: ['form'],

    data() {
      return {
        siteSearch: this.$store.getters.siteSearch
      }
    },

    components: {
      LoadingButton,
      DatePicker,
      MaskedInput
    },

    computed: {
      contracts() {
        return this.$store.getters.contracts;
      },
      municipalities() {
        return this.$store.getters.municipalities;
      },
      applicators() {
        return this.$store.getters.applicators;
      },
      zones() {
        return this.$store.getters.zones;
      },
      mosquitoes() {
        return this.$store.getters.mosquitoSpecies;
      },
      workStatus() {
        return this.$store.getters.workStatus;
      },
    },

    methods: {
      zoneName(id) {
        return this.$store.getters.zoneNameById(id);
      },
      routeName(id) {
        return this.$store.getters.routeNameById(id);
      },
      stateName(id) {
        return this.$store.getters.stateNameById(id);
      },
      setSelected() {
        this.$store.dispatch('setSiteSearchSelected', this.form.data.siteId);
      },
      newSite() {
        this.form.hideEdit();
        this.$router.push({name: 'data-sites-new'})
      },
      addMosquito() {
        if (typeof(this.form.data.landingRateMosquitoes) !== 'object') {
          this.form.data.landingRateMosquitoes = [];
        }

        this.form.data.landingRateMosquitoes.push({ landingRateMosquitoes: null, mosquitoCount: null });
        this.$forceUpdate();
      },
      removeMosquito(index) {
        this.$forceUpdate();
        this.form.data.landingRateMosquitoes.splice(index, 1);
      },
    }

  }

</script>